// Google tag (gtag.js) loader — inactive until REACT_APP_GTAG_ID is set.
// Used for Google Ads conversion tracking / GA4.

const GTAG_ID = process.env.REACT_APP_GTAG_ID;

export function initGtag() {
  if (!GTAG_ID) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GTAG_ID}`;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GTAG_ID);
}

export function gtagEvent(name, params = {}) {
  if (typeof window.gtag === "function") window.gtag("event", name, params);
}
